<div class="connector-management">
  <div class="card">
    <div class="group-header">
      <div class="flex-start">
        <button class="btn btn-primary-soft flex-start" (click)="goBack()" style="margin-left: 10px;">
          <i class="fa fa-arrow-left color-inherit"></i> Back
        </button>
        <h5>Connectors for Group: {{ groupId }}</h5>
      </div>
      <div style="display: flex; justify-content: flex-end; align-items: center;">
        <button class="btn btn-primary-soft flex-start" (click)="openConnectorModal()">
          <i class="fa fa-plus color-inherit"></i> Add Connector
        </button>
      </div>
    </div>
    <div class="card-body">
      <div *ngIf="isLoadingConnectors" class="text-center p-4">
        <span class="spinner-border spinner-border-sm"></span>
        <span class="ms-2">Loading connectors...</span>
      </div>
      <div class="table-responsive" *ngIf="!isLoadingConnectors">
        <table class="table table-docs table-hover">
          <thead>
            <tr>
              <th>Type</th>
              <th>Protocol</th>
              <th>Hostname</th>
              <th>Port</th>
              <th class="text-center">Status</th>
              <th class="text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let connector of connectors">
              <td>{{ connector.Type || connector.type }}</td>
              <td>{{ connector.Protocol || connector.protocol }}</td>
              <td>{{ connector.Hostname || connector.hostname }}</td>
              <td>{{ connector.Port || connector.port }}</td>
              <td class="text-center">
                <span class="badge"
                  [ngClass]="(connector.Enabled !== undefined ? connector.Enabled : connector.enabled) ? 'badge-success' : 'badge-danger'">
                  {{ (connector.Enabled !== undefined ? connector.Enabled : connector.enabled) ? 'Enabled' :
                  'Disabled' }}
                </span>
              </td>
              <td class="text-center">
                <button class="btn btn-sm btn-primary-soft" (click)="openConnectorModal(connector)" title="Edit">
                  <i class="fa fa-edit"></i>
                </button>
                <button class="btn btn-sm btn-warning-soft" (click)="toggleConnectorStatus(connector)"
                  title="{{ (connector.Enabled !== undefined ? connector.Enabled : connector.enabled) ? 'Disable' : 'Enable' }}">
                  <i class="fa"
                    [ngClass]="(connector.Enabled !== undefined ? connector.Enabled : connector.enabled) ? 'fa-toggle-off' : 'fa-toggle-on'"></i>
                </button>
                <button class="btn btn-sm btn-danger-soft"
                  (click)="deleteConnector(connector.Id?.toString() || connector.id || '')" title="Delete">
                  <i class="fa fa-trash"></i>
                </button>
              </td>
            </tr>
            <tr *ngIf="connectors.length === 0">
              <td colspan="6" class="text-center">No connectors found in this group. Please add a connector.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<!-- Connector Modal -->
<div class="popup-screen" *ngIf="showConnectorModal">
  <div class="popup-container">
    <div class="popup-header">
      {{ editMode ? 'Edit' : 'Add' }} Connector
      <button type="button" class="close" (click)="closeConnectorModal()">
        &times;
      </button>
    </div>
    <div class="popup-body">
      <form [formGroup]="connectorForm">
        <div class="form-group">
          <label for="type">Type <span class="required">*</span></label>
          <select id="type" class="form-select" formControlName="type">
            <option *ngFor="let type of connectorTypeOptions" [value]="type">{{ type }}</option>
          </select>
        </div>
        <div class="form-group">
          <label for="protocol">Protocol <span class="required">*</span></label>
          <select id="protocol" class="form-select" formControlName="protocol">
            <option *ngFor="let protocol of connectorProtocolOptions" [value]="protocol">{{ protocol }}</option>
          </select>
        </div>
        <div class="form-group">
          <label for="hostname">Hostname <span class="required">*</span></label>
          <input type="text" id="hostname" class="form-control" formControlName="hostname" placeholder="Enter hostname">
        </div>
        <div class="form-group">
          <label for="port">Port <span class="required">*</span></label>
          <input type="number" id="port" class="form-control" formControlName="port" placeholder="Enter port number"
            min="0" max="65535">
        </div>
        <div class="form-group">
          <div class="switch-container flex-start">
            <label class="switch m-0">
              <input type="checkbox" formControlName="enabled">
              <span class="slider"></span>
            </label> <span>{{ connectorForm.get('enabled')?.value ? 'Enabled' : 'Disabled' }}</span>
          </div>
        </div>
      </form>
    </div>
    <div class="button-container flex-end">
      <button type="button" class="btn btn-light-soft" (click)="closeConnectorModal()">Cancel</button>
      <button type="button" class="btn btn-primary-soft" (click)="saveConnector()"
        [disabled]="connectorForm.invalid">
        {{ editMode ? 'Update' : 'Create' }}
      </button>
    </div>
  </div>
</div>

<!-- Confirmation Modal -->
<div class="popup-screen confirm-modal" *ngIf="showConfirmModal">
  <div class="popup-container">
    <div class="popup-header">
      {{ confirmModalData.title }}
      <button type="button" class="close" (click)="closeConfirmModal()">
        &times;
      </button>
    </div>
    <div class="popup-body">
      <p>{{ confirmModalData.message }}</p>
    </div>
    <div class="button-container flex-end">
      <button type="button" class="btn btn-light-soft" (click)="closeConfirmModal()">
        Cancel
      </button>
      <button type="button" class="btn btn-primary-soft" (click)="confirmModalData.onConfirm()" [disabled]="isLoadingConnectors">
        <span *ngIf="isLoadingConnectors" class="spinner-border spinner-border-sm me-1"></span>
        {{ confirmModalData.confirmText || 'Confirm' }}
      </button>
    </div>
  </div>
</div>
